export const ApiConstant = {
  ENCODER_OPERATION_TIMEOUT: 58000,
  READ_SLIDER_TIMEOUT: 10000,

  localUrl: "http://localhost:44383/api/v1/",
  baseUrl: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrl2: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlV2: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlV4: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",

  baseUrlCoreApi: "https://integra-cloud-demo-api.myamadeo.net/api/v1/",
  baseUrlNotify: "https://integra-cloud-api.myamadeo.net",

  // baseUrl: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/",
  // baseUrl2: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/",
  // baseUrlV2: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/",
  // baseUrlV4: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/",

  // baseUrlCoreApi: "https://www.skyaccess.eu/IntegraDemoAPi/api/v1/",
  // baseUrlNotify: "https://www.skyaccess.eu/IntegraDevApiV4",

  // baseUrl: "http://localhost:44383/api/v1/",
  // baseUrl2: "http://localhost:44383/api/v1/",
  // baseUrlV2: "http://localhost:44383/api/v1/",
  // baseUrlV4: "http://localhost:44383/api/v1/",

  // baseUrlCoreApi: "http://localhost:7535/api/v1/",
  // baseUrlNotify: "http://localhost:44383",

  // baseUrl: "https://integra-cloud-api.myamadeo.com/api/v1/",
  // baseUrl2: "https://integra-cloud-api.myamadeo.com/api/v1/",
  // baseUrlV2: "https://integra-cloud-api.myamadeo.com/api/v1/",
  // baseUrlV4: "https://integra-cloud-api.myamadeo.com/api/v1/",

  // baseUrlCoreApi: "https://integra-cloud-apicore.myamadeo.com/api/v1/",
  // baseUrlNotify: "https://integra-cloud-api.myamadeo.com",

  baseUrlBooking: "https://www.skyaccess.eu/IntegraDemoAPi/api/v1/",
};

// export const ApiConstant = {
//   baseUrl: "https://www.skyaccess.eu/IntegraDevApi/api/",
//   baseUrl2: "https://www.skyaccess.eu/SandboxAPIv1/api/v1/",
//   baseUrlV2: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/",
//   baseUrlV4: "https://www.skyaccess.eu/IntegraDevApiV4/api/v1/"
// };

//https://www.skyaccess.eu/IntegraDevApiV4/api/v1/

export enum DataRequestType {
  RECEIVED,
  PENDING,
  APPROVED,
  REJECTED,
}

export const CARD_STATUS = [
  {
    key: 0,
    value: "ACTIVE",
  },
  {
    key: 1,
    value: "BLOCKED",
  },
  {
    key: 3,
    value: "LOST",
  },
];

export const CARD_TECHNOLOGY = [
  {
    key: 0,
    value: "UNKNOWN",
  },
  {
    key: 1,
    value: "Mifare Ultralight (Including C)",
  },
  {
    key: 2,
    value: "Mifare Classic (1K,4K)",
  },
  {
    key: 3,
    value: "Mifare Plus",
  },
  {
    key: 4,
    value: "Mifare Desfire (EV1,EV2,EV3)",
  },
];

export const MEDIUM_TYPE = [
  {
    key: 0,
    value: "UNKNOWN",
  },
  {
    key: 1,
    value: "Arm band - Bracelet",
  },
  {
    key: 2,
    value: "Card",
  },
  {
    key: 3,
    value: "Key Fob",
  },
  {
    key: 4,
    value: "Mobile",
  },
];

export const PROFILE_STATUS = [
  {
    key: 0,
    value: "ACTIVE",
  },
  {
    key: 1,
    value: "BLOCKED",
  },
  {
    key: 2,
    value: "INACTIVE",
  },
  {
    key: 3,
    value: "UNIQUE",
  },
  {
    key: 4,
    value: "VIP_ACTIVE",
  },
  {
    key: 5,
    value: "ALWAYS_ACTIVE",
  },
  {
    key: 6,
    value: "PIN_ACTIVE",
  },
];

export const NEW_TICKET_CATEGORY = [
  {
    key: 0,
    value: "ACCESS CONTROL",
  },
  {
    key: 1,
    value: "SKY ACCESS",
  },
  {
    key: 2,
    value: "HARDWARE",
  },
  {
    key: 3,
    value: "PRODUCT LIST",
  },
];

export const NEW_TICKET_PRIORITY = [
  {
    key: 0,
    value: "NORMAL",
  },
  {
    key: 1,
    value: "LOW",
  },
  {
    key: 2,
    value: "HIGH",
  },
];
export const DISPLAY_DENSITY = ["compact", "cosy", "comfortable"];

export const STATUS_CODE = {
  success: 0,
};

export const countries = [
  { name: "Afghanistan", code: "AF" },
  { name: "land Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: 'Cote D"Ivoire', code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: 'Korea, Democratic People"S Republic of', code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: 'Lao People"S Democratic Republic', code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

export const CheckinStatus = [
  {
    name: "UNKNOW",
    color: "white",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "CHECKED-IN",
    color: "green",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "CHECKEDOUT",
    color: "red",
    border: "1px solid #FF0000 !important",
  },
  {
    name: "PRECHECKIN",
    color: "yellow",
    border: "1px solid #FFFF00 !important",
  },
  {
    name: "EXPIRED",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
];

export const CheckinPersonStatus = [
  {
    name: "UNKNOW",
    color: "white",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "ACTIVE",
    color: "green",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "INACTIVE",
    color: "red",
    border: "1px solid #FF0000 !important",
  },
  {
    name: "BLOCKED",
    color: "yellow",
    border: "1px solid #FFFF00 !important",
  },
  {
    name: "EXPIRED",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
];

export const AccessCardStatus = [
  {
    name: "ACTIVE",
    color: "green",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "BLOCKED",
    color: "red",
    border: "1px solid #FF0000 !important",
  },
  {
    name: "LOST",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
];

export const PersonStatus = [
  {
    name: "UNKNOW",
    color: "white",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "BLOCKED",
    color: "red",
    border: "1px solid #FF0000 !important",
  },
  {
    name: "ACTIVE",
    color: "green",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "HOLIDAY",
    color: "yellow",
    border: "1px solid #FFFF00 !important",
  },
  {
    name: "INACTIVE",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
  {
    name: "SICK",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
];

export const PersonType = [
  {
    name: "UNKNOW",
    color: "white",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "EMPLOYEE",
    color: "red",
    border: "1px solid #FF0000 !important",
  },
  {
    name: "GUEST",
    color: "green",
    border: "1px solid #00FF00 !important",
  },
  {
    name: "HOLIDAY",
    color: "yellow",
    border: "1px solid #FFFF00 !important",
  },
  {
    name: "VISITOR",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
  {
    name: "MEMBER",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
  {
    name: "SYSTEM",
    color: "orangered",
    border: "1px solid #ff4500 !important",
  },
];

export enum PERSON_TYPE {
  UNKNOW = 0,
  EMPLOYEE,
  GUEST,
  VISITOR,
  MEMBER,
  SYSTEM,
}

export enum ACCESSCARD_STATUS {
  ACTIVE,
  BLOCKED,
  LOST,
}

export enum CHECKIN_STATUS {
  UNKNOW,
  CHECKEDIN,
  CHECKEDOUT,
  PRECHECKIN,
  EXPIRED,
}

export enum PERSON_STATUS {
  UNKNOW,
  BLOCKED,
  ACTIVE,
  HOLIDAY,
  INACTIVE,
  SICK,
}

export const TimeZones = [
  {
    LANGID: 0,
    TIMEZONEID: 0,
    _Description: "All Time Zones",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 1,
    TIMEZONEID: 1,
    _Description: "Time Zone 1",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 2,
    TIMEZONEID: 2,
    _Description: "Time Zone 2",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 3,
    TIMEZONEID: 3,
    _Description: "Time Zone 3",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 4,
    TIMEZONEID: 4,
    _Description: "Time Zone 4",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 5,
    TIMEZONEID: 5,
    _Description: "Time Zone 5",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 6,
    TIMEZONEID: 6,
    _Description: "Time Zone 6",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 7,
    TIMEZONEID: 7,
    _Description: "Time Zone 7",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 8,
    TIMEZONEID: 8,
    _Description: "Time Zone 8",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 9,
    TIMEZONEID: 9,
    _Description: "Time Zone 9",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 10,
    TIMEZONEID: 10,
    _Description: "Time Zone 10",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 11,
    TIMEZONEID: 11,
    _Description: "Time Zone 11",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 12,
    TIMEZONEID: 12,
    _Description: "Time Zone 12",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 13,
    TIMEZONEID: 13,
    _Description: "Time Zone 13",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 14,
    TIMEZONEID: 14,
    _Description: "Time Zone 14",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 15,
    TIMEZONEID: 15,
    _Description: "Time Zone 15",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 16,
    TIMEZONEID: 16,
    _Description: "Time Zone 16",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 17,
    TIMEZONEID: 17,
    _Description: "Time Zone 17",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 18,
    TIMEZONEID: 18,
    _Description: "Time Zone 18",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 19,
    TIMEZONEID: 19,
    _Description: "Time Zone 19",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 20,
    TIMEZONEID: 20,
    _Description: "Time Zone 20",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 21,
    TIMEZONEID: 21,
    _Description: "Time Zone 21",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 22,
    TIMEZONEID: 22,
    _Description: "Time Zone 22",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 23,
    TIMEZONEID: 23,
    _Description: "Time Zone 23",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 24,
    TIMEZONEID: 24,
    _Description: "Time Zone 24",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 25,
    TIMEZONEID: 25,
    _Description: "Time Zone 25",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 26,
    TIMEZONEID: 26,
    _Description: "Time Zone 26",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 27,
    TIMEZONEID: 27,
    _Description: "Time Zone 27",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 28,
    TIMEZONEID: 28,
    _Description: "Time Zone 28",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 29,
    TIMEZONEID: 29,
    _Description: "Time Zone 29",
    _Profiles: 0,
    _Shifts: 0,
  },
  {
    LANGID: 30,
    TIMEZONEID: 30,
    _Description: "Time Zone 30",
    _Profiles: 0,
    _Shifts: 0,
  },
];

export const TimeShifts = [
  {
    TIMEEND: "23:59",
    ONFRIDAY: 0,
    ONMONDAY: 0,
    ONSUNDAY: 0,
    _Enabled: 0,
    ONHOLIDAY: 0,
    ONTUESDAY: 0,
    TIMESTART: "00:00",
    time_zone: {
      LANGID: 1,
      _Description: null,
    },
    ONSATURDAY: 0,
    ONTHURSDAY: 0,
    TIMEZONEID: 1,
    ONWEDNESDAY: 0,
    TIMESHIFTID: 0,
    _TimeShiftNumber: 1,
  },
  {
    TIMEEND: "23:59",
    ONFRIDAY: 0,
    ONMONDAY: 0,
    ONSUNDAY: 0,
    _Enabled: 0,
    ONHOLIDAY: 0,
    ONTUESDAY: 0,
    TIMESTART: "00:00",
    time_zone: {
      LANGID: 1,
      _Description: null,
    },
    ONSATURDAY: 0,
    ONTHURSDAY: 0,
    TIMEZONEID: 2,
    ONWEDNESDAY: 0,
    TIMESHIFTID: 0,
    _TimeShiftNumber: 2,
  },
  {
    TIMEEND: "23:59",
    ONFRIDAY: 0,
    ONMONDAY: 0,
    ONSUNDAY: 0,
    _Enabled: 0,
    ONHOLIDAY: 0,
    ONTUESDAY: 0,
    TIMESTART: "00:00",
    time_zone: {
      LANGID: 1,
      _Description: null,
    },
    ONSATURDAY: 0,
    ONTHURSDAY: 0,
    TIMEZONEID: 3,
    ONWEDNESDAY: 0,
    TIMESHIFTID: 0,
    _TimeShiftNumber: 3,
  },
  {
    TIMEEND: "23:59",
    ONFRIDAY: 0,
    ONMONDAY: 0,
    ONSUNDAY: 0,
    _Enabled: 0,
    ONHOLIDAY: 0,
    ONTUESDAY: 0,
    TIMESTART: "00:00",
    time_zone: {
      LANGID: 1,
      _Description: null,
    },
    ONSATURDAY: 0,
    ONTHURSDAY: 0,
    TIMEZONEID: 4,
    ONWEDNESDAY: 0,
    TIMESHIFTID: 0,
    _TimeShiftNumber: 4,
  },
  {
    TIMEEND: "23:59",
    ONFRIDAY: 0,
    ONMONDAY: 0,
    ONSUNDAY: 0,
    _Enabled: 0,
    ONHOLIDAY: 0,
    ONTUESDAY: 0,
    TIMESTART: "00:00",
    time_zone: {
      LANGID: 1,
      _Description: null,
    },
    ONSATURDAY: 0,
    ONTHURSDAY: 0,
    TIMEZONEID: 5,
    ONWEDNESDAY: 0,
    TIMESHIFTID: 0,
    _TimeShiftNumber: 5,
  },
];

export class UtilService {
  public static GetTK(): any {
    try {
      /* if not expired, bla bla */
      var tmp = atob(sessionStorage.getItem("TK"));
      return JSON.parse(tmp)?.access_token;
    } catch (ex) {
      //this.LogEx("GetTK :" + ex.message);
      return "";
    }
  }

  public static GetTKV2(): any {
    try {
      /* if not expired, bla bla */
      var tmp = atob(sessionStorage.getItem("token"));
      return JSON.parse(tmp)?.access_token;
    } catch (ex) {
      //this.LogEx("GetTK :" + ex.message);
      return "";
    }
  }

  public static GetTOKENKV2(): any {
    try {
      /* if not expired, bla bla */
      var tmp = atob(sessionStorage.getItem("token"));
      return tmp;
    } catch (ex) {
      //this.LogEx("GetTK :" + ex.message);
      return "";
    }
  }

  public static GetSystemCode(IsNumber: boolean = false): any {
    try {
      /* if not expired, bla bla */
      var tmp = atob(sessionStorage.getItem("Perm"));
      return !IsNumber
        ? JSON.parse(tmp)?._SysNumber.toString(16)
        : JSON.parse(tmp)?._SysNumber;
    } catch (ex) {
      //this.LogEx("GetSystemCode :" + ex.message);
      return "";
    }
  }

  public static GetEncoderID(): any {
    try {
      var tmp = localStorage.getItem("_EncoderID");
      return tmp === undefined || tmp === null ? 1 : tmp;
    } catch (ex) {
      //this.LogEx("GetEncoderID :" + ex.message);
      return "";
    }
  }

  public static GetCheckinMsgRslt(Res: string): any {
    switch (Res) {
      case "ADD_CARD_FAILED":
        return {
          msg: "Adding guest copy card has failed, make sure the encoder is connected.",
          color: "danger",
          result: 1,
        };

      case "READ_CARD_FAILED":
        return {
          msg: "Reading card has failed, make sure the encoder is connected.",
          color: "danger",
          result: 1,
        };

      case "READ_CARD_SUCCESS":
        return { msg: "Read card succeeded.", color: "success", result: 0 };

      case "DELETE_CARD_FAILED":
        return {
          msg: "Delete card has failed, make sure the encoder is connected.",
          color: "danger",
          result: 1,
        };

      case "DELETE_CARD_SUCCESS":
        return {
          msg: "The Card has been successfully deleted.",
          color: "success",
          result: 0,
        };

      case "MOBILE_KEY_FAILED":
        return {
          msg: "Mobile key sent has failed !",
          color: "danger",
          result: 1,
        };

      case "MOBILE_KEY_SUCCESS":
        return {
          msg: "Mobile Key sent successfully.",
          color: "success",
          result: 0,
        };

      case "NEW_CHECKIN_FAILED":
        return {
          msg: "Guest Checkin has failed, make sure the encoder is connected.",
          color: "danger",
          result: 1,
        };

      case "NEW_CHECKIN_SUCCESS":
        return {
          msg: "Checkin successfully performed.",
          color: "success",
          result: 0,
        };

      case "ADD_CARD_SUCCESS":
        return {
          msg: "Adding guest copy card successfull.",
          color: "success",
          result: 0,
        };

      case "NEW_PERSON_CHECKIN_FAILED":
        return {
          msg: "Add card has failed, make sure the profiles is well configurated and the encoder connected !",
          color: "danger",
          result: 1,
        };

      case "NEW_PERSON_CHECKIN_SUCCESS":
        return {
          msg: "Card successfully issued and added .",
          color: "success",
          result: 0,
        };

      case "CHECKOUT_FAILED":
        return {
          msg: "The checkout has failed, try again !",
          color: "danger",
          result: 1,
        };

      case "CHECKOUT_SUCCESS":
        return { msg: "Checkout successfull.", color: "success", result: 0 };

      default:
        return undefined;
    }
  }

  public static GetItemFromArray(items: any) {
    var item = "";
    for (let i = 0; i < items.length; i++) {
      if (i == 0) item += items[i];
      else item += ", " + items[i];
    }

    return item;
  }

  public static IsvalidateEmail(Email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(Email).toLowerCase());
  }

  public static GetVisitorText() {
    var Tmp = sessionStorage.getItem("AppVersion");
    if (Tmp === "HOSPITALYTY") return "GUEST";
    else return "VISITOR";
  }
}
